<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('text.baseInfo')" name="detail">
          <div class="drawer-content with-tab-footer">
            <el-form
              ref="returnedMaterialForm"
              :model="returnedMaterial"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('returnedMaterial.serialNo')">{{
                      returnedMaterial.serialNo
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.warehouses')">{{
                      returnedMaterial.warehouseName
                    }}</el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('text.owner')">{{
                      returnedMaterial.ownerName
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.verifyAt')">{{
                      returnedMaterial.verifyAt
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('procure.verifyName')">{{
                      returnedMaterial.verifyName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">{{
                      returnedMaterial.createdAt
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('returnedMaterial.finishAt')">{{
                      returnedMaterial.finishAt
                    }}</el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('returnedMaterial.finishName')">{{
                      returnedMaterial.finishName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('settlement.amount')">
                      {{ computeTotal() | currency4 }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset>
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="returnedMaterial.remark" />
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.materials')" name="item">
          <div class="drawer-content with-tab-footer">
            <vxe-table
              :data="items"
              row-id="id"
              ref="procureItemsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="materialSerialNo"
                :title="$t('material.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.materialSerialNo }}
                  <div class="font10">
                    {{ row.materialName }} {{ row.subjectName }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="color"
                :title="$t('material.color')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.color }}

                  <div class="font10">{{ row.colorNo }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit }}
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="price"
                :title="$t('material.price')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  {{ row.price | currency4 }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="6"
                    type="richText"
                  />
                </template>
              </vxe-table-column>
              <vxe-table-column
                v-if="
                  Permit.canActionsChargeEdition('mmsReturnedMaterialManage') &&
                  returnedMaterial.verifyAt == null
                "
                field="action"
                :title="$t('text.action')"
                width="100"
              >
                <template v-slot="{ row }">
                  <el-button type="text" size="mini" @click="editItem(row)">{{
                    $t("text.edit")
                  }}</el-button>
                  <el-popconfirm
                    :title="$t('prompt.confirmDelete')"
                    @confirm="deleteItem(row)"
                    class="mgl10"
                  >
                    <el-button slot="reference" type="text" size="mini">
                      {{ $t("text.delete") }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button
        v-if="activeName == 'detail'"
        size="small"
        type="default"
        @click="print('printDiv')"
      >
        {{ $t("action.print") }}
      </el-button>

      <el-button
        v-if="
          activeName == 'item' &&
          Permit.canActionsChargeEdition('mmsProcureManage') &&
          returnedMaterial.verifyAt == null
        "
        type="success"
        size="small"
        @click="addItem"
        >+ {{ $t("menu.materials") }}</el-button
      >
    </div>
    <!-- 编辑 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editItemDF"
      width="30%"
    >
      <el-form ref="editItemForm" :model="editItemObj" label-width="60px">
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editItemObj.quantity"
            :placeholder="editItemObj._invQuantity"
          >
            <template slot="append" v-if="row">{{ row.unit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :prop="'price'"
          :label="$t('material.price')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.price')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="editItemObj.price" />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="editItemObj.remark"
            type="textarea"
            :placeholder="$t('text.remark')"
            :rows="4"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editItemDoing"
          size="small"
          @click="editItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增项 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addItemDF"
      width="30%"
    >
      <el-form ref="addItemForm" :model="addItemObj" label-width="70px">
        <el-form-item
          :prop="'materialSerialNo'"
          :label="$t('material.serialNo')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.serialNoName')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-autocomplete
            size="small"
            v-model.trim="addItemObj.materialSerialNo"
            :placeholder="$t('material.serialNoName')"
            style="width: 100%"
            :fetch-suggestions="querySearchSerialNo"
            @select="handleSelectSerialNo"
          />
        </el-form-item>
        <el-form-item
          v-if="addItemObj.inventoryId != null"
          :prop="'quantity'"
          :label="$t('product.materialInfo')"
        >
          {{ addItemObj.materialName }} {{ addItemObj.subjectName }}
          {{ addItemObj.color }}
          <small>({{ addItemObj.colorNo }})</small>
        </el-form-item>
        <el-form-item
          :prop="'quantity'"
          :label="$t('text.quantity')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.quantity')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addItemObj.quantity"
            :placeholder="addItemObj._invQuantity"
          >
            <template slot="append">{{ addItemObj.unit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item
          :prop="'price'"
          :label="$t('material.price')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('material.price')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addItemObj.price"
            :placeholder="addItemObj._price"
          />
        </el-form-item>
        <el-form-item :prop="'remark'" :label="$t('text.remark')">
          <el-input
            size="small"
            v-model.trim="addItemObj.remark"
            type="textarea"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addItemDoing"
          size="small"
          @click="addItemSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addItemDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <div id="printDiv" style="display: none">
      <div style="font-size: 12px">
        <div style="width: 100%; text-align: center; font-size: 16px">
          退料单
        </div>
        <br />
        <div>
          <div>
            <div style="float: left">
              {{ $t("returnedMaterial.serialNo") }}：{{
                returnedMaterial.serialNo
              }}
              <span style="margin-left: 20px"
                >{{ $t("menu.warehouses") }}：{{
                  returnedMaterial.warehouseName
                }}</span
              >
            </div>
            <div style="float: right">
              {{ $t("text.ownerName") }}：{{ returnedMaterial.ownerName }}&nbsp;
              &nbsp;{{ $t("text.createAt") }}：{{ returnedMaterial.createdAt }}
            </div>
          </div>
          <br />
          <div>
            <div style="float: left">
              {{ $t("text.remark") }}：{{ returnedMaterial.remark }}
            </div>
            <div style="float: right">
              {{ $t("procure.verifyName") }}：{{
                returnedMaterial.verifyName
              }}&nbsp; &nbsp;{{ $t("procure.verifyAt") }}：{{
                returnedMaterial.verifyAt
              }}
            </div>
          </div>
        </div>
        <div>
          <table
            style="
              width: 100%;
              border-collapse: collapse;
              border: 1px solid black;
              font-size: 12px;
            "
          >
            <thead>
              <tr style="border: 1px solid black">
                <td style="border: 1px solid black">
                  {{ $t("material.serialNo") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.name") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.subject") }}
                </td>
                <td style="border: 1px solid black; width: 120px">
                  {{ $t("material.color") }}
                </td>
                <td style="border: 1px solid black; width: 80px">
                  {{ $t("text.quantity") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("material.price") }}
                </td>
                <td style="border: 1px solid black">
                  {{ $t("text.remark") }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) of items"
                :key="index"
                style="border: 1px solid black"
              >
                <td style="border: 1px solid black">
                  {{ item.materialSerialNo }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.materialName }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.subjectName }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.color }}({{ item.colorNo }})
                </td>

                <td style="border: 1px solid black">
                  {{ item.quantity }}{{ item.unit }}
                </td>
                <td style="border: 1px solid black">
                  {{ item.price | currency4 }}
                </td>
                <td style="border: 1px solid black; width: 200px">
                  {{ item.remark }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import ReturnedMaterial from "@/api/returnedMaterial.js";
import InventoryMms from "@/api/inventoryMms.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    RawHtmlLimitNumber,
    UploadSinglePicture,
  },
  data() {
    return {
      activeName: "detail",
      returnedMaterial: { serialNo: "newly" },
      items: [],
      // 编辑明细
      row: null,
      editItemDF: false,
      editItemObj: {
        quantity: null,
        price: null,
        remark: null,
        _invQuantity: null,
      },
      editItemDoing: false,
      // 新增项
      addItemDF: false,
      invMaterials: [],
      addItemObj: {
        inventoryId: null,
        materialId: null,
        materialSerialNo: null,
        materialName: null,
        subjectId: null,
        subjectName: null,
        color: null,
        colorNo: null,
        unit: null,
        quantity: null,
        price: null,
        remark: null,
        _invQuantity: null,
        _price: null,
      },
      addItemDoing: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    // 打印采购单
    print(type) {
      this.printFunction(type);
    },

    loadData() {
      const self = this;
      self.loadingStart();
      axios
        .all([
          ReturnedMaterial.findById(self.id),
          ReturnedMaterial.findItems(self.id),
        ])
        .then(
          axios.spread(function (returnedMaterial, items) {
            self.loadingEnd();
            if (returnedMaterial.data.code === 200) {
              self.returnedMaterial = returnedMaterial.data.entity;
            } else {
              self.sysError();
            }
            if (items.status === 200) {
              self.items = items.data;
            } else {
              self.sysError();
            }
          })
        );
    },
    computeTotal() {
      let total = 0;
      if (this.items.length !== 0) {
        for (const item of this.items) {
          total = total + item.price * item.quantity;
        }
        return total;
      }
      return 0;
    },

    // 新增采购单项
    addItem() {
      const self = this;
      self.addItemObj.inventoryId = null;
      self.addItemObj.materialId = null;
      self.addItemObj.materialSerialNo = null;
      self.addItemObj.materialName = null;
      self.addItemObj.subjectId = null;
      self.addItemObj.subjectName = null;
      self.addItemObj.color = null;
      self.addItemObj.colorNo = null;
      self.addItemObj.unit = null;
      self.addItemObj.quantity = null;
      self.addItemObj.price = null;
      self.addItemObj.remark = null;
      self.addItemObj._invQuantity = null;
      self.addItemDoing = false;
      self.addItemDF = true;
    },
    querySearchSerialNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      InventoryMms.vagueFindBySerialNo({
        serialNo: queryString,
        warehouseId: self.returnedMaterial.warehouseId,
      }).then(function (res) {
        self.invMaterials = res.data;
        if (self.invMaterials.length !== 0) {
          for (const invMaterial of self.invMaterials) {
            Vue.set(invMaterial, "value", invMaterial.materialSerialNo);
          }
        }
        cb(self.invMaterials);
      });
    },
    handleSelectSerialNo(item) {
      const self = this;
      if (
        self.items.find((i) => i.materialSerialNo === item.material.serialNo) !=
        null
      ) {
        self.addItemObj.materialSerialNo = null;
        self.$message({
          message: self.$t("rules.exist", [self.$t("material.serialNo")]),
          type: "warning",
        });
      } else {
        self.addItemObj.inventoryId = item.id;
        self.addItemObj.materialId = item.materialId;
        self.addItemObj.materialSerialNo = item.material.serialNo;
        self.addItemObj.materialName = item.material.name;
        self.addItemObj.subjectId = item.material.subjectId;
        self.addItemObj.subjectName = item.material.subjectName;
        self.addItemObj.color = item.material.color;
        self.addItemObj.colorNo = item.material.colorNo;
        self.addItemObj.unit = item.material.unit;
        self.addItemObj.quantity = null;
        self.addItemObj.price = null;
        self.addItemObj.remark = null;
        self.addItemObj._invQuantity = item.storeQuantity;
        self.addItemObj._price = item.price;
      }
    },
    addItemSubmit() {
      const self = this;
      self.$refs.addItemForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.addItemObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("material.price")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.addItemObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          if (self.addItemObj.quantity > self.addItemObj._invQuantity) {
            self.$message({
              message: self.$t("rules.beyondMaxQty", [
                self.addItemObj._invQuantity,
              ]),
              type: "warning",
            });
            return;
          }
          self.addItemDoing = true;
          ReturnedMaterial.addItem(
            self.returnedMaterial.id,
            self.addItemObj
          ).then(function (res) {
            self.addItemDoing = false;
            self.addItemDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除明细
    deleteItem(row) {
      const self = this;
      ReturnedMaterial.deleteItem(self.returnedMaterial.id, row.id).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        }
      );
    },

    // 编辑
    editItem(row) {
      const self = this;
      self.row = row;
      self.editItemObj.quantity = row.quantity;
      self.editItemObj.price = row.price;
      self.editItemObj.remark = row.remark;
      InventoryMms.findBySerialNoWithWarehouse({
        serialNo: row.materialSerialNo,
        warehouseId: self.returnedMaterial.warehouseId,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.editItemObj._invQuantity = res.data.entity.storeQuantity;
        } else {
          self.editItemObj._invQuantity = 0;
        }
      });

      self.editItemDoing = false;
      self.editItemDF = true;
    },
    editItemSubmit() {
      const self = this;
      this.$refs.editItemForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editItemObj.price)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("material.price")]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.editItemObj.quantity)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          if (self.editItemObj.quantity > self.editItemObj._invQuantity) {
            self.$message({
              message: self.$t("rules.beyondMaxQty", [
                self.editItemObj._invQuantity,
              ]),
              type: "warning",
            });
            return;
          }
          self.editItemDoing = true;
          ReturnedMaterial.updateItem(
            self.returnedMaterial.id,
            self.row.id,
            self.editItemObj
          ).then(function (res) {
            if (res.status === 200) {
              self.editItemDoing = false;
              self.editItemDF = false;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // checkboxChangeEvent({ records }) {
    //   this.isAllChecked = this.$refs.procureItemsTable.isAllCheckboxChecked();
    //   this.isIndeterminate = this.$refs.procureItemsTable.isCheckboxIndeterminate();
    //   this.selectProcureItems = records;
    // },
    // changeAllEvent() {
    //   this.$refs.procureItemsTable.setAllCheckboxRow(this.isAllChecked);
    //   this.selectProcureItems = this.$refs.procureItemsTable.getCheckboxRecords();
    // },
    // getProcure() {
    //   const self = this;
    //   self.loadingStart();
    //   Procure.findById(self.id).then(function (res) {
    //     if (res.data.code === 200) {
    //       self.procure = res.data.entity;
    //     } else {
    //       self.sysError();
    //     }
    //     self.loadingEnd();
    //   });
    // },
    // getItems() {
    //   const self = this;
    //   Procure.findItems(self.id).then(function (res) {
    //     if (res.status === 200) {
    //       self.items = res.data;
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },
  },
};
</script>